import { Divider, styled } from '@mui/material';

const AppbarDivider = styled(Divider)(({ theme }) => ({
  backgroundColor: theme.palette.custom.neutral[300],
  height: '100%'
}));

export default AppbarDivider;
